import React, { useState, useEffect } from 'react';
import {
  FaTachometerAlt,
  FaClipboardList,
  FaStore,
  FaTruck,
  FaChartBar,
  FaCogs,
  FaBuilding,
  FaShoppingCart,
  FaShippingFast,
  FaCheckCircle,
  FaBars,
  FaTimes,
  FaBell,
  FaDatabase,
  FaStar,
  FaEye,
  FaRoute,
  FaProjectDiagram,
  FaServer,
  FaCode,
  FaTasks,
  FaLaptopCode,
  FaHistory,
  FaInbox,
  FaChevronDown,
  FaChevronRight,
  FaFileAlt,
  FaRupeeSign
} from 'react-icons/fa';
import '../css/admin/AdminSidebar.css';

const AdminSidebar = ({ activeSection, setActiveSection, userRole }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const [expandedSections, setExpandedSections] = useState({
    'OVERVIEW': true,
    'VERIFICATION & APPROVALS': true,
    'BUSINESS MANAGEMENT': true,
    'DELIVERY MANAGEMENT': true,
    'PORTER SERVICE': true,
    'COMMUNICATION': true,
    'ANALYTICS & REPORTS': true,
    'ACTIVITY LOGS': true,
    'KIRAZEE ECOSYSTEM': true
  });

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setIsMobileOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleMobileSidebar = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const handleNavClick = (itemId) => {
    setActiveSection(itemId);
    window.location.hash = itemId;
    if (isMobile) {
      setIsMobileOpen(false);
    }
  };

  const toggleSection = (heading) => {
    setExpandedSections(prev => ({
      ...prev,
      [heading]: !prev[heading]
    }));
  };

  const baseMenuItems = [
    {
      id: 'dashboard',
      label: 'DASHBOARD OVERVIEW',
      icon: <FaTachometerAlt />
    },
    {
      id: 'sow-documentation',
      label: 'SOW DOCUMENTATION',
      icon: <FaFileAlt />
    },
    {
      heading: 'VERIFICATION & APPROVALS',
      items: [
        { id: 'business-review', label: 'Business Merchant KYC', icon: <FaCheckCircle /> },
        { id: 'delivery-partner-review', label: 'Delivery Partner KYC', icon: <FaTruck /> }
      ]
    },
    {
      heading: 'BUSINESS MANAGEMENT',
      items: [
        { id: 'businesses', label: 'Business Management', icon: <FaStore /> },
        { id: 'orders', label: 'Order Management', icon: <FaClipboardList /> },
        { id: 'order-history', label: 'Order History', icon: <FaHistory /> }
      ]
    },
    {
      heading: 'DELIVERY MANAGEMENT',
      items: [
        { id: 'delivery', label: 'Delivery Partner Management', icon: <FaClipboardList /> },
        { id: 'fleet-statistics', label: 'Fleet Operations & Analytics', icon: <FaTruck /> },
        { id: 'fleet-comparison', label: 'Fleet Comparison', icon: <FaChartBar /> },
        { id: 'delivery-order-management', label: 'Delivery Order Management', icon: <FaShippingFast /> }
      ]
    },
    {
      heading: 'PORTER SERVICE',
      items: [
        { id: 'order-routing', label: 'Order Routing', icon: <FaRoute /> }
      ]
    },
    {
      heading: 'COMMUNICATION',
      items: [
        { id: 'notifications', label: 'Notification Management', icon: <FaBell /> },
        { id: 'contact-inbox', label: 'Contact Inbox', icon: <FaInbox /> }
      ]
    },
    // {
    //   heading: 'ANALYTICS & REPORTS',
    //   items: [
    //     { id: 'analytics', label: 'Business Analytics & Reports', icon: <FaChartBar /> },
    //     { id: 'sales-reports', label: 'Sales Reports', icon: <FaChartBar /> }
    //   ]
    // },
    {
      id: 'activity-logs',
      label: 'ACTIVITY LOGS',
      icon: <FaHistory />
    },
    {
      id: 'kirazee-management',
      label: 'KIRAZEE MANAGEMENT',
      icon: <FaCogs />
    },
    {
      heading: 'KIRAZEE ECOSYSTEM',
      items: [
        { id: 'product-vision', label: 'Product Vision & Roadmap', icon: <FaEye /> },
        { id: 'user-journey', label: 'User Journey & User Flows', icon: <FaRoute /> },
        { id: 'order-lifecycle', label: 'Order Lifecycle Management', icon: <FaTasks /> },
        { id: 'system-architecture', label: 'System & Platform Architecture', icon: <FaProjectDiagram /> },
        { id: 'database-design', label: 'Database Design', icon: <FaServer /> },
        { id: 'api-specifications', label: 'API & Service Specifications', icon: <FaCode /> },
        { id: 'operational-workflows', label: 'Operational Workflows', icon: <FaTasks /> },
        { id: 'frontend-architecture', label: 'Frontend Architecture', icon: <FaLaptopCode /> }
      ]
    }
  ];

  const getIcon = (iconName) => {
    const icons = {
      'FaTachometerAlt': <FaTachometerAlt />,
      'FaClipboardList': <FaClipboardList />,
      'FaStore': <FaStore />,
      'FaTruck': <FaTruck />,
      'FaChartBar': <FaChartBar />,
      'FaCogs': <FaCogs />,
      'FaBuilding': <FaBuilding />,
      'FaShoppingCart': <FaShoppingCart />,
      'FaShippingFast': <FaShippingFast />,
      'FaCheckCircle': <FaCheckCircle />,
      'FaBell': <FaBell />,
      'FaDatabase': <FaDatabase />,
      'FaStar': <FaStar />,
      'FaEye': <FaEye />,
      'FaRoute': <FaRoute />,
      'FaProjectDiagram': <FaProjectDiagram />,
      'FaServer': <FaServer />,
      'FaCode': <FaCode />,
      'FaTasks': <FaTasks />,
      'FaLaptopCode': <FaLaptopCode />,
      'FaHistory': <FaHistory />,
      'FaInbox': <FaInbox />,
      'FaFileAlt': <FaFileAlt />
    };
    return icons[iconName] || <FaCheckCircle />;
  };

  const getDynamicMenuItems = () => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        const roleLower = (user.role || '').toLowerCase();
        const isSuperAdminOrAdmin = roleLower === 'superadmin' || roleLower === 'admin';
        if (!isSuperAdminOrAdmin && user.navigation_items && user.navigation_items.length > 0) {
          const navItems = user.navigation_items;
          const dynamicMenu = [];
          const headingMap = {};

          navItems.forEach(item => {
            if (item.sub_nav) {
              if (!headingMap[item.nav_name]) {
                const newSection = {
                  heading: item.nav_name,
                  items: []
                };
                headingMap[item.nav_name] = newSection;
                dynamicMenu.push(newSection);
              }
              headingMap[item.nav_name].items.push({
                id: item.route_path ? item.route_path.replace(/^\/+/, '') : item.sub_nav.toLowerCase().replace(/\s+/g, '-'),
                label: item.sub_nav,
                icon: getIcon(item.icon)
              });
            } else {
              dynamicMenu.push({
                id: item.route_path ? item.route_path.replace(/^\/+/, '') : item.nav_name.toLowerCase().replace(/\s+/g, '-'),
                label: item.nav_name,
                icon: getIcon(item.icon)
              });
            }
          });
          return dynamicMenu;
        }
      }
    } catch (error) {
      console.error('Error parsing dynamic menu', error);
    }
    return null;
  };

  const menuItems = getDynamicMenuItems() || baseMenuItems;

  return (
    <>
      {/* Mobile Toggle Button */}
      {isMobile && (
        <button
          className="mobile-sidebar-toggle"
          onClick={toggleMobileSidebar}
          aria-label="Toggle sidebar"
        >
          {isMobileOpen ? <FaTimes /> : <FaBars />}
        </button>
      )}

      {/* Mobile Overlay */}
      {isMobile && isMobileOpen && (
        <div
          className="mobile-sidebar-overlay"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div className={`admin-sidebar ${isMobileOpen ? 'mobile-open' : ''}`}>
        {/* Navigation Menu */}
        <nav className="admin-nav">
          {menuItems.map((sectionOrItem, idx) => {
            if (sectionOrItem.heading) {
              const section = sectionOrItem;
              return (
                <div key={`section-${idx}`} className="nav-section">
                  <div
                    className="nav-section-header"
                    onClick={() => toggleSection(section.heading)}
                  >
                    <span className="nav-section-title">{section.heading}</span>
                    {expandedSections[section.heading] ? (
                      <FaChevronDown className="nav-section-chevron" />
                    ) : (
                      <FaChevronRight className="nav-section-chevron" />
                    )}
                  </div>

                  {expandedSections[section.heading] && (
                    <div className="nav-section-items">
                      {section.items.map((item, itemIdx) => {
                        const isActive = activeSection === item.id;
                        return (
                          <button
                            key={item.id || `item-${itemIdx}`}
                            className={`nav-item ${isActive ? 'active' : ''}`}
                            onClick={() => handleNavClick(item.id)}
                            data-active={isActive ? 'true' : 'false'}
                            data-item-id={item.id}
                            data-tooltip={item.label}
                          >
                            <span className="nav-icon">{item.icon}</span>
                            <div className="nav-content">
                              <span className="nav-label">
                                {item.label}
                                {item.badge && <span className="nav-badge">{item.badge}</span>}
                              </span>
                              <span className="nav-description">{item.description}</span>
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            } else {
              const item = sectionOrItem;
              const isActive = activeSection === item.id;
              return (
                <div key={`item-${idx}`} className="nav-section">
                  <div
                    className="nav-section-header"
                    onClick={() => handleNavClick(item.id)}
                    style={{ justifyContent: 'flex-start', gap: '8px' }}
                  >
                    <span className="nav-icon" style={{ color: isActive ? '#F55D00' : '#6b7280', margin: 0, opacity: 0.85, width: 'auto', minWidth: 'auto', fontSize: '14px' }}>
                      {item.icon}
                    </span>
                    <span className="nav-section-title" style={{ color: isActive ? '#F55D00' : '#2A2C41' }}>
                      {item.label}
                    </span>
                  </div>
                </div>
              );
            }
          })}
        </nav>
      </div>
    </>
  );
};

export default AdminSidebar;
